var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-card',{attrs:{"type":"inner","size":"small"}},[_c('a-skeleton',{attrs:{"loading":_vm.loading,"active":""}},[_c('performance-report-table',{attrs:{"type":_vm.type,"data":_vm.tableData,"title":_vm.title}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }